import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { StyledLoading, ROOT_PREFIX } from './loadingStyles';
export var EmbersLoading = function EmbersLoading(_ref) {
  var _classnames;
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    className = _ref.className;
  var rootCls = className ? classnames((_classnames = {
    'icon-loading': true
  }, _defineProperty(_classnames, "".concat(ROOT_PREFIX, "-").concat(size), size), _defineProperty(_classnames, className, className), _classnames)) : classnames(_defineProperty({
    'icon-loading': true
  }, "".concat(ROOT_PREFIX, "-").concat(size), size));
  return /*#__PURE__*/React.createElement(StyledLoading, {
    className: rootCls,
    size: size
  });
};